var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"loading",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('img',{staticClass:"flex",attrs:{"src":require("../assets/img/loading.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }